import { Children } from "react"

export const warrantyFlagMapping = {
  "NOT_KEEP_UNDER_WARRANTY": "No",
  "KEEP_UNDER_WARRANTY": "Yes",
}

export const warrantyRangeMapping = {
  "ALL_KEEP_UNDER_WARRANTY": "Full",
  "PART_UNDER_WARRANTY": "Limited",
}

export const isProduction =
  process.env.NEXT_PUBLIC_ISDev === "true"
    ?
    false
    :
    process.env.NEXT_PUBLIC_ISTest === "true" ? false : true

export enum PrivacyPolicyPagesEnum {
  /**隐私政策 */
  PrivacyPolicy = "privacy-policy",
  /**服务政策 */
  TermsofService = "termsof-service",
  /**退货政策 */
  ReturnPolicy = "return-policy",
  /**运费政策 */
  ShippingCosts = "shipping-costs",
}

export enum FaqPageEnum {
  /**产品材质 */
  AboutOurProducts = "AboutOurProducts",
  /**订购运输 */
  OrderingShipping = "OrderingShipping",
  /**支付定价 */
  PaymentPricing = "PaymentPricing",
  /**组装保养 */
  AssemblyCare = "AssemblyCare",
  /**退换货保修 */
  ReturnsWarranty = "ReturnsWarranty",
  /**客户支持 */
  CustomerSupport = "CustomerSupport",
}

// 这里可以实现更复杂的逻辑，例如使用第三方库生成模糊数据 URL
// 为了简单起见，这里返回一个占位符

// export const getBlurDataURL = 'data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==';

export const categoryData = [
  {
    id: "1",
    foreignCategoryName: 'Sofas',
    categoryUrl: 'https://www.bravve.com/collections/sofa-1893849704015175680.html',
    // children: [
    //   {
    //     id: '12',
    //     foreignCategoryName: 'Traditional Sofas',
    //     categoryUrl: 'https://www.bravve.com/collections/traditional-sofas-1905178422666969088.html',
    //     icon: '/img/category/Traditional Sofas.webp'
    //   },
    //   {
    //     id: '13',
    //     foreignCategoryName: 'Loveseats',
    //     categoryUrl: 'https://www.bravve.com/collections/loveseats-1905178645275459584.html',
    //     icon: '/img/category/Loveseats.webp'
    //   },
    //   {
    //     id: '14',
    //     foreignCategoryName: 'Sleeper Sofas',
    //     categoryUrl: 'https://www.bravve.com/collections/sleeper-sofas-1905179647978356736.html',
    //     icon: '/img/category/Sleeper Sofas.webp'
    //   },
    //   {
    //     id: '15',
    //     foreignCategoryName: 'Modular Sofas',
    //     categoryUrl: 'https://www.bravve.com/collections/modular-sofas-1905179944511455232.html',
    //     icon: '/img/category/Modular Sofas.webp'
    //   },
    //   {
    //     id: '16',
    //     foreignCategoryName: 'Sectionals',
    //     categoryUrl: 'https://www.bravve.com/collections/sectional-sofas-1905180222539284480.html',
    //     icon: '/img/category/Sectionals.webp'
    //   },
    //   {
    //     id: '17',
    //     foreignCategoryName: 'Leather Sofas',
    //     categoryUrl: 'https://www.bravve.com/collections/leather-sofas-1905180402256822272.html',
    //     icon: '/img/category/Leather Sofas.webp'
    //   }
    // ]
  },
  {
    id: "2",
    foreignCategoryName: 'Accent Tables',
    categoryUrl: 'https://www.bravve.com/collections/tables-chairs-1905068642124283904.html',
    // children: [
    //   {
    //     id: '22',
    //     foreignCategoryName: 'Coffee Tables',
    //     categoryUrl: 'https://www.bravve.com/collections/coffee-tables-1897532691848105984.html',
    //     icon: '/img/category/Coffee Tables.webp'
    //   },
    //   {
    //     id: '23',
    //     foreignCategoryName: 'Side Tables',
    //     categoryUrl: 'https://www.bravve.com/collections/side-tables-1893852470410321920.html',
    //     icon: '/img/category/Side Tables.webp'
    //   }
    // ]
  },
  {
    id: "3",
    foreignCategoryName: 'TV Stands',
    categoryUrl: 'https://www.bravve.com/collections/tv-stands-1904827261254483968.html'
  },
  {
    id: "4",
    foreignCategoryName: 'Beds',
    categoryUrl: 'https://www.bravve.com/collections/bed-1893851567758352384.html'
  },
  {
    id: "5",
    foreignCategoryName: 'New',
    categoryUrl: 'https://www.bravve.com/collections/new-arrivals-1904827953943789568.html'
  },
  {
    id: "6",
    foreignCategoryName: 'Sale',
    categoryUrl: 'https://www.bravve.com/collections/sale-1904828311881498624.html'
  }
]

